import { Body1, mqDown } from '../../../../theme';
import styled from 'styled-components6';

const DescriptionContainer = styled(Body1)`
    overflow: hidden;
    text-overflow: ellipsis;
    margin: var(--rwl-spacing-sm) 0;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    ${mqDown('md')} {
        display: none;
    }
    ${mqDown('sm')} {
        display: auto;
    }
`;

type JobDescriptionProps = {
    description?: string;
};

export const JobDescription = ({
    description,
}: JobDescriptionProps): JSX.Element => {
    return <DescriptionContainer>{description}</DescriptionContainer>;
};
